import { hasImageInput, clampTo } from '../../tools';
import type { grsaiModelConfig } from '../types';
import { resolveOpenaiSize } from '../../openai-sizes';
import { UPSCALE_PROMPT, REFRAME_PROMPT, REPAINT_PROMPT_PREFIX } from '../../wrapped-prompts';

const WRAPPED_BASE = {
    apiPath: '/v1/api/generate',
    pollApiPath: '/v1/api/result?id={id}',
    statusMapping: {
        taskIdPath: 'id',
        createErrorPath: 'error',
        statePath: 'status',
        success: ['succeeded'],
        failed: ['failed', 'violation'],
        processing: ['running'],
        errorPath: 'error',
        imageUrlPath: 'results[0].url',
    },
    enableTranslation: false,
} satisfies Partial<grsaiModelConfig>;

export const wrappedConfigs: Record<string, grsaiModelConfig> = {
    'gpt-image-2-upscale': {
        ...WRAPPED_BASE,
        buildInput: (params) => {
            const { image_urls } = params;
            return {
                model: 'gpt-image-2-vip',
                prompt: UPSCALE_PROMPT,
                aspectRatio: 'auto',
                // 图像 URL
                images: image_urls.slice(0, 1),
                // system
                replyType: 'async',
            };
        },
    },
    'gpt-image-2-reframe': {
        ...WRAPPED_BASE,
        buildInput: (params) => {
            const { image_urls, aspectRatio, image_resolution } = params;
            return {
                model: 'gpt-image-2-vip',
                prompt: REFRAME_PROMPT,
                aspectRatio: resolveOpenaiSize(
                    clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:1', '1:3', '3:2', '2:3', '2:1', '1:2', '1:1'] as const, '16:9'),
                    image_resolution || '1K',
                ),
                images: image_urls.slice(0, 1),
                // system
                replyType: 'async',
            };
        },
    },
    'gpt-image-2-repaint': {
        ...WRAPPED_BASE,
        buildInput: (params) => {
            const { prompt, image_urls } = params;
            return {
                model: 'gpt-image-2-vip',
                prompt: `${REPAINT_PROMPT_PREFIX}${prompt || ''}`,
                aspectRatio: 'auto',
                // 图像 URL
                images: image_urls.slice(0, 2),
                // system
                replyType: 'async',
            };
        },
    },
};